<template>
  <div class="app-evn-settings-wrapper" ref="wrapper">
    <SimonModal
      :is-visible="showUnsavedChangesModal"
      @hide="revertChanges"
      id="unsaved-changed-modal"
      show-footer-buttons
      @btnLeft="revertChanges"
      @btnRight="save"
      btn-left-title="Verwerfen"
      btn-right-title="Übernehmen"
    >
      <template v-slot:modalTitle>
        <h1><slot name="txtUnsavedChangesHeadlineModal"></slot></h1>
      </template>
      <slot name="txtUnsavedChangesModal"></slot>
    </SimonModal>
    <b-form>
      <b-row class="top-row">
        <div class="evn-header">
          <slot name="evnHeader"></slot>
        </div>
        <EvnSelect :evn-selected.sync="evnSetting" :plain-radio="true">
          <template v-for="slot in possibleChildSlotsFor('Select')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </EvnSelect>
      </b-row>
      <b-row>
        <div class="error-box" v-if="!loadingNext && showError" v-html="errorMsg">
        </div>
      </b-row>
      <b-row class="text-center mt-4">
        <button @click.prevent.stop="save" :disabled="loadingNext"><slot name="btnSave">Speichern</slot></button>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import transaction from '@/mixins/transaction'
import { mapActions } from 'vuex'
import EvnSelect from '@/components/generic/EvnSelect.vue'
import { BRow } from 'bootstrap-vue'
import { splitError } from '@/helper/splitError'
import beErrors from '@/mixins/beErrors'
import SimonModal from '@/components/modal/SimonModal.vue'

const defaultEvnSetting = 'ANO'

export default {
  name: 'ChangeEvnWrapper',
  data () {
    return {
      originEvnSetting: null,
      showUnsavedChangesModal: false,
      currentEvnConfiguration: {
        evn: null
      },
      evnSetting: defaultEvnSetting,
      loadingNext: false,
      showError: false,
      errorMsg: '',
      eventListenerAdded: false
    }
  },
  components: {
    SimonModal,
    EvnSelect,
    BRow
  },
  mixins: [
    transaction('changeEvnSettings'),
    beErrors
  ],
  watch: {
    evnSetting: function () {
      this.addConfirmEventListener()
    }
  },
  methods: {
    ...mapActions('evn', [
      'saveEvnSettings'
    ]),
    addConfirmEventListener: function () {
      if (!this.eventListenerAdded) {
        window.addEventListener('beforeunload', this.handleUnload)
        window.addEventListener('pagehide', this.handleUnload)
        document.addEventListener('click', this.documentClick)
        this.eventListenerAdded = true
      }
    },
    handleUnload (e) {
      if (this.evnChanged) {
        e.returnValue = 'Wenn sie diese Seite verlassen werden ihre Änderungen nicht gespeichert'
        return 'Wenn sie diese Seite verlassen werden ihre Änderungen nicht gespeichert'
      }
      return false
    },
    documentClick (e) {
      if (this.evnChanged && !this.showUnsavedChangesModal && !this.loadingNext) {
        const el = this.$refs.wrapper
        if (el && el !== e.target && !el.contains(e.target)) {
          this.showUnsavedChangesModal = true
        }
      }
    },
    revertChanges () {
      this.showUnsavedChangesModal = false
      this.evnSetting = this.originEvnSetting
    },
    save: async function () {
      this.showUnsavedChangesModal = false
      this.loadingNext = true
      this.showError = false
      this.saveEvnSettings({ selectedEvn: this.evnSetting }).then(() => {
        if (this.beHasErrorMessages()) {
          throw new Error(this.getSlotText('txtNetworkError'))
        }

        this.successToast(this.$slots.txtToastEVNSettingsSaved ? this.$slots.txtToastEVNSettingsSaved[0].text : 'Die Einstellung wurde erfolgreich gespeichert.')
        this.loadingNext = false
        this.originEvnSetting = this.evnSetting
      }).catch((e) => {
        this.loadingNext = false
        this.showError = true
        this.errorMsg = e.message
      })
    }
  },
  computed: {
    evnChanged: function () {
      return (this.evnSetting !== this.originEvnSetting)
    },
    getBackendErrorMessage: function () {
      return this.beErrorGetLastMessage()
    }
  },
  apollo: {
    currentEvnConfiguration: function () {
      return wrapQuery(
        gql`query changeEvnSettings {
          currentEvnConfiguration {
              evn
          }
        }`, this, 'currentEvnConfiguration', {},
        // callback
        () => {
          if (typeof this.currentEvnConfiguration?.evn === 'undefined' || this.currentEvnConfiguration.evn === '' || this.currentEvnConfiguration.evn === null) {
            this.evnSetting = defaultEvnSetting
          } else {
            this.evnSetting = this.currentEvnConfiguration.evn
          }

          this.originEvnSetting = JSON.parse(JSON.stringify(this.evnSetting))
          this.showError = false
        },
        {},
        // error callback
        (error) => {
          splitError(error).forEach(e => {
            this.errorMsg = e.message
          })
          if (!this.showError) {
            const data = {
              type: 'technical',
              message: this.errorMsg
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
          this.showError = true
        }
      )
    }
  }
}
</script>
